import Api from "./baseApi";
export default {
  searchStock: Stock => {
    let url = "/api/stocks?v=1";
    if (Stock.search) url += `&q=${Stock.search}`;
    if (Stock.state > -1) url += `&state=${Stock.state}`;
    if (Stock.startDate) url += `&startDate=${Stock.startDate}`;
    if (Stock.endDate) url += `&endDate=${Stock.endDate}`;
    return Api.get(url);
  },
  getStocks: () => Api.get("/api/Stocks"),
  getStock: id => Api.get(`/api/Stocks/${id}`),
  putStock: Stock => Api.put(`/api/Stocks/${Stock.id}`, Stock),
  deleteStock: Stock => Api.delete(`/api/Stocks/${Stock.id}`, Stock),
  postStock: Stock => Api.post(`/api/Stocks`, Stock),
  bulkUpdateStates: Model => Api.post(`/api/stocks/BulkStock`, Model)
};
